import React, { useState } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { Page, LayoutSideNavigation, H3 } from '../components';
import TopbarContainer from '../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../containers/FooterContainer/FooterContainer';

import BillingDetailsForm from './BillingDetailsForm';
import css from './BillingDetailsPage.module.css';
import { updateProfile } from '../containers/ProfileSettingsPage/ProfileSettingsPage.duck';
import { ensureCurrentUser } from '../util/data';
import { FormattedMessage } from '../util/reactIntl';
import { isScrollingDisabled } from '../ducks/ui.duck';

export const BILLING_ENTITY_TYPES = {
  INDIVIDUAL: 'individual',
  COMPANY: 'company',
};

const isBillingEntityType = value => Object.values(BILLING_ENTITY_TYPES).includes(value);

export const getBillingDetailsInitialValues = (billingDetails = {}) => ({
  entityType: isBillingEntityType(billingDetails.entityType)
    ? billingDetails.entityType
    : BILLING_ENTITY_TYPES.INDIVIDUAL,
  companyName: billingDetails.companyName || '',
  vatNumber: billingDetails.vatNumber || '',
  addressLine1: billingDetails.addressLine1 || '',
  addressLine2: billingDetails.addressLine2 || '',
  city: billingDetails.city || '',
  postalCode: billingDetails.postalCode || '',
  country: billingDetails.country || 'Thailand',
});

export const getBillingDetailsUpdateParams = (publicData, billingDetails, values) => ({
  publicData: {
    ...publicData,
    billingDetails: {
      ...billingDetails,
      ...values,
    },
  },
});

export const BillingDetailsPageComponent = props => {
  const { currentUser, onUpdateProfile, scrollingDisabled } = props;

  const ensuredCurrentUser = ensureCurrentUser(currentUser);
  const publicData = ensuredCurrentUser?.attributes?.profile?.publicData || {};

  const billingDetails = publicData.billingDetails || {};

  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState(null);

  const initialValues = getBillingDetailsInitialValues(billingDetails);

  const handleSubmit = async values => {
    try {
      setError(null);
      setInProgress(true);

      await onUpdateProfile(getBillingDetailsUpdateParams(publicData, billingDetails, values));
    } catch (e) {
      setError(e?.message || 'Failed to save billing details.');
    } finally {
      setInProgress(false);
    }
  };

  return (
    <Page title="Billing Details" scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        topbar={<TopbarContainer />}
        sideNav={null}
        useAccountSettingsNav
        currentPage="BillingDetailsPage"
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <H3>
            <FormattedMessage id="LayoutWrapperAccountSettingsSideNav.billingDetailsPage" />
          </H3>
          <p className={css.subtitle}>
            <FormattedMessage id="BillingDetailsPage.subtitle" />
          </p>
          <BillingDetailsForm
            initialValues={initialValues}
            onSubmit={handleSubmit}
            inProgress={inProgress}
            error={error}
          />
        </div>
      </LayoutSideNavigation>
    </Page>
  );
};

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
  scrollingDisabled: isScrollingDisabled(state),
});

const mapDispatchToProps = dispatch => ({
  onUpdateProfile: params => dispatch(updateProfile(params)),
});

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(BillingDetailsPageComponent);
